import Vue from 'vue';
import Vuex from 'vuex';
import cardTypes from './modules/card-types';
import clients from './modules/clients';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    loading: false,
  }
};

// initial state
const state = getDefaultState();

export default new Vuex.Store({
  strict: true,
  state: state,
  getters: {},
  actions: {},
  mutations: {
    init: (state) => {
      Object.assign(state, getDefaultState());
    },
    setLoading: (state, value) => {
      state.loading = value;
    }
  },
  modules: {
    'card-types': cardTypes,
    clients,

  }
});
